module.exports = __webpack_public_path__ + "img/img_cursos.f15c1a14.png";